import { Auth, IAuthState, IAuthDispatch } from "./auth/auth";

import { Models } from "@rematch/core";
import {
  Applications,
  IApplicationsState,
  IApplicationsDispatch
} from "./applications/applications";

import {
  Payments,
  IPaymentState,
  IPaymentDispatch
} from "./payment/PaymentModule";
import {
  IWeworkDispatch,
  IWeworkState,
  WeworkModule
} from "./wework/WeworkModule";
import {
  IMembersChatState,
  IMembersChatDispatch,
  MembersChatModule
} from "./membersChat/MembersChatModule";
import {
  ReferralsModule,
  IReferralsState,
  IReferralsDispatch
} from "./referrals/ReferralsModule";
import {
  ActionsModule,
  IActionsState,
  IActionsDispatch
} from "./actions/ActionsModule";
import {
  ICommonBotState,
  CommonBotModule,
  ICommonBotDispatch
} from "./commonBot/CommonBotModule";
import {
  IPartnersBotDispatch,
  IPartnersBotState,
  PartnersBotModule
} from "./partnersBot/PartnersBotModule";
import { StateModules } from "./types";

const auth: StateModules = "auth";
const applications: StateModules = "applications";
const payment: StateModules = "payment";
const weworkCampaign: StateModules = "weworkCampaign";
const membersChat: StateModules = "membersChat";
const referrals: StateModules = "referrals";
const actions: StateModules = "actions";
const commonBot: StateModules = "commonBot";
const partners: StateModules = "partners";

export const models: Models = {
  [auth]: Auth,
  [applications]: Applications,
  [payment]: Payments,
  [weworkCampaign]: WeworkModule,
  [membersChat]: MembersChatModule,
  [referrals]: ReferralsModule,
  [actions]: ActionsModule,
  [commonBot]: CommonBotModule,
  [partners]: PartnersBotModule
};

export interface IState {
  [auth]: IAuthState;
  [applications]: IApplicationsState;
  [payment]: IPaymentState;
  [weworkCampaign]: IWeworkState;
  [membersChat]: IMembersChatState;
  [referrals]: IReferralsState;
  [actions]: IActionsState;
  [commonBot]: ICommonBotState;
  [partners]: IPartnersBotState;
}

export interface IDispatch {
  [auth]: IAuthDispatch;
  [applications]: IApplicationsDispatch;
  [payment]: IPaymentDispatch;
  [weworkCampaign]: IWeworkDispatch;
  [membersChat]: IMembersChatDispatch;
  [referrals]: IReferralsDispatch;
  [actions]: IActionsDispatch;
  [commonBot]: ICommonBotDispatch;
  [partners]: IPartnersBotDispatch;
}

export default models;



// WEBPACK FOOTER //
// ./src/state/modules/index.ts